import { useCallback, useMemo, useState } from 'react';

import { Button } from '@webapp/common/components/button';
import { Password } from '@webapp/common/components/password';
import { setHtml } from '@webapp/common/lib/ui';

import { selectInfo, selectPwdError } from '@webapp/survey/src/machine/selectors';
import { SurveyState } from '@webapp/survey/src/machine/states';
import { useStateSelector } from '@webapp/survey/src/machine/use-state-selector';
import { useStore } from '@webapp/survey/src/store';

import css from './auth.css';

export const PwdAuth: VFC = () => {
    const { send, state } = useStore();
    const {
        design: {
            fonts: { fieldBorderColor },
        },
        params: {
            main: { passwordLabel },
        },
    } = useStateSelector(selectInfo);
    const error = useStateSelector(selectPwdError);
    const [password, setPassword] = useState('');
    const loading = state === SurveyState.authCheckPwd && !error;
    const borderStyle = useMemo(() => ({ borderColor: fieldBorderColor }), [fieldBorderColor]);

    const submit = useCallback(() => {
        send({ type: 'AUTH_CHECK_PWD', password });
    }, [password, send]);

    return (
        <div className={css.box} style={borderStyle}>
            <div className={css.title} {...setHtml(passwordLabel)} />
            <div className={css.form}>
                <Password
                    value={password}
                    onChange={setPassword}
                    onEnter={submit}
                    style={fieldBorderColor ? { boxShadow: `0 2px 0 ${fieldBorderColor}` } : null}
                />
                {error && <div className={css.error} {...setHtml(error)} />}
                <Button fluid color='blue' loading={loading} onClick={submit}>
                    ОК
                </Button>
            </div>
        </div>
    );
};
PwdAuth.displayName = 'PwdAuth';
